import * as Api from './api';

export async function getAccessToken() {
	const data = await Api.get<{ access_token: string; report_id: string; group_id: string }>(`mi/access-token`);

	return data;
}
